/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { intl } from "../services/intlGlobalProvider";
import styled from "styled-components";
import PropTypes from "prop-types";
import Theme from "../utils/Theme";
import Toast from "../utils/Toast";
import Color from "../utils/Color";

const StyledContainer = styled.div`
  cursor: pointer;
  padding: ${props => (props.showText ? "0 15px" : "0")};
  min-height: 2em;
  background: ${props =>
    props.disabled ? Color.highlightRedTextColor : Theme.PrimaryColor};
  color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 6px -5px grey;
  border-radius: 2px;
`;

const StyledButton = styled.button`
  background: ${Theme.PrimaryColor};
  display: flex;
  border-width: 0px;
  padding: 0px;
  width: ${props => (props.showText ? "1em" : "2em")};
  height: ${props => (props.showText ? "auto" : "2em")};
  justify-content: center;
  align-items: center;
  font-size: 1em;
`;

const StyledTitle = styled.span`
  margin-left: 5px;
  font-size: 0.8em;
  text-transform: uppercase;
`;

class AddToCartButton extends Component {
  render() {
    const { onClicked, showText, textOnly, disabled, displayText } = this.props;

    return (
      <StyledContainer
        disabled={disabled}
        showText={showText}
        className={"opacity"}
        onClick={e => {
          e.stopPropagation();

          if (disabled) {
            Toast.warning(
              intl.formatMessage({ id: "product.selection.purchase.not.allow" })
            );
            return;
          }

          onClicked && onClicked();
        }}
      >
        {textOnly || disabled ? null : (
          <StyledButton showText={showText}>
            <img
              src={require("../assets/icons/basket_512.png")}
              style={{ width: "1em", height: "1em" }}
            />
          </StyledButton>
        )}
        {disabled ? (
          <StyledTitle>
            <FormattedMessage
              id="product.selection.not.available.title"
              defaultMessage="Not Available"
              description="Product Selection Not Available Title"
            />
          </StyledTitle>
        ) : showText ? (
          <StyledTitle>
            {displayText ? (
              displayText
            ) : (
              <FormattedMessage
                id="product.selection.addtocart.title"
                defaultMessage="ADD TO CART"
                description="Product Selection Add To Cart Title"
              />
            )}
          </StyledTitle>
        ) : null}
      </StyledContainer>
    );
  }
}

AddToCartButton.propTypes = {
  onClicked: PropTypes.func.isRequired,
  showText: PropTypes.bool,
  textOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  displayText: PropTypes.string
};

AddToCartButton.defaultProps = {
  showText: false,
  textOnly: false
};

export default AddToCartButton;



// WEBPACK FOOTER //
// ./src/components/AddToCartButton.js